export const SET_BENCHMARKS = 'benchmark/SET_BENCHMARKS';
export const SET_BENCHMARK = 'benchmark/SET_BENCHMARK';
export const ADDING_BENCHMARK = 'benchmark/ADD_BENCHMARK';
